import { useAuth } from '@cibo/profile'
import { Tabs } from '@cibo/ui'
import { Badge, Tab, TabProps, TabsProps } from '@mui/material'
import { Link, LinkProps, useLocation } from 'react-router-dom'

export interface PageLink extends TabProps, Pick<LinkProps, 'to'> {
  label: string
  count?: number
  countColor?: 'success' | 'default' | 'error' | 'primary' | 'secondary' | 'info' | 'warning'
  exact?: boolean
}

export interface SecondaryNavigationProps extends Pick<TabsProps, 'orientation' | 'sx'> {
  basePath?: string
  pageLinks: Array<PageLink>
}

export const SecondaryNavigation = ({
  basePath = '',
  pageLinks,
  ...tabsProps
}: SecondaryNavigationProps) => {
  const { pathname } = useLocation()
  const { persona } = useAuth()

  if (!persona) {
    return null
  }

  const value = pageLinks.some(p => p.exact && pathname === p.to)
    ? pathname
    : pathname
        .split('/')
        .slice(0, basePath.split('/').length + 1)
        .join('/')

  const legalValues = pageLinks.map(l => l.to)

  return (
    <Tabs
      value={legalValues.includes(value) ? value : false}
      variant="scrollable"
      scrollButtons="auto"
      {...tabsProps}
    >
      {pageLinks.map(({ count, countColor, label, to, ...tabProps }) => (
        // @ts-ignore
        <Tab
          key={label}
          {...{ ...tabProps, exact: undefined }}
          value={to}
          data-testid={`nav-${label}`}
          label={
            <Badge
              color={!!countColor ? countColor : 'secondary'}
              badgeContent={count}
              sx={{ '.MuiBadge-anchorOriginTopRight': { top: -4, right: -8 } }}
            >
              {label}
            </Badge>
          }
          component={Link}
          to={to}
        />
      ))}
    </Tabs>
  )
}
